import React, { useState } from "react";
import { isAndroid, isIOS, isMobileOnly } from "react-device-detect";
import { WithReset } from "src/sudokit/Layout/BoxReset";
import InlineSVG from "react-inlinesvg";
import { Input } from "src/sudokit/components/Input";
import { SudoButton } from "src/sudokit/components/SudoButton";

export const MobileRedirect = () => {
  const [email, setEmail] = useState("");
  const [error, setError] = useState("");

  const redirectToMobileAppListing = () => {
    if (isMobileOnly && isIOS) {
      window.location.href = "https://apps.apple.com/app/sudowrite/id6740884542";
    } else if (isMobileOnly && isAndroid) {
      window.location.href = "https://play.google.com/store/apps/details?id=com.humanplusplus.sudowrite&pcampaignid=mobile_redirect";
    }
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    // clear previous errors when resubmitting
    setError("");

    try {
      const response = await fetch("/api/promo/email", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          email,
          promo: "Author Nation 50k",
        }),
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.message || `HTTP error! status: ${response.status}`);
      }

      // Clear the email field on success
      setEmail("");
      redirectToMobileAppListing();
    } catch (error) {
      setError("Could not submit email, please try again");
    }
  };

  return (
    <WithReset className="flex flex-col mx-4 mt-[26px] mb-[50px] justify-between min-h-[85vh]">
      {/* Email Input Section */}
      <WithReset className="flex flex-col gap-4 w-full rounded-xl px-4 py-5 bg-app-menu-color border border-app-grey-3">
        <h1 className="text-center text-app-grey-0 font-gt-super-text italic text-[40px] font-normal leading-normal mb-[15px]">Pssst!</h1>
        <p className="text-center text-app-grey-0 font-inter text-base font-medium leading-[1.5]">
          Enter your email and we'll give you <br /> <strong className="text-app-primary-cta-high-contrast font-bold">50,000 bonus credits</strong> <br /> for installing the Sudowrite app.
        </p>
        <p className="text-center text-app-grey-1 font-inter text-sm italic font-normal px-6 mb-[10px]">
          Valid for new, existing and returning Sudowrite users—just be sure to use the same email when logging into the app, and note that bonus credits may take ~24 hours to appear.
        </p>

        <form
          onSubmit={handleSubmit}
          className="flex flex-col gap-3 w-full items-center pb-[20px] px-[14px]"
        >
          <div className="w-full max-w-md flex flex-col gap-3">
            {error && (
              <div className="flex items-center justify-center gap-2.5 text-app-danger-color text-center leading-[1.4] px-3 py-2 rounded-lg border border-app-grey-3">
                <InlineSVG
                  src="/assets/warning-square.svg"
                  className="flex-shrink-0 [&>path]:fill-app-danger-color"
                />
                <span className="text-sm">{error}</span>
              </div>
            )}
            <Input
              type="email"
              mode="default"
              placeholder="Enter your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="text-center bg-app-document-background focus:border-app-primary-cta"
            />
          </div>
          <SudoButton
            type="submit"
            variant="primary"
            size="default"
            disabled={!email}
          >
            Submit
          </SudoButton>
        </form>
      </WithReset>

      {/* Mobile App Download Section */}
      <WithReset className="flex flex-col gap-4 w-full rounded-xl px-4 py-5 bg-app-menu-color border border-app-grey-3">
        <p className="text-center font-medium text-lg font-sans text-app-grey-0 leading-6">To use Sudowrite on a mobile device, download our app for the best experience!</p>

        <div className="flex flex-row gap-3 items-center justify-center max-h-12 px-3">
          <div className="max-w-[9.5rem] w-full">
            <a
              href="https://apps.apple.com/app/sudowrite/id6740884542"
              target="_blank"
            >
              <InlineSVG
                src="/assets/apple-logo.svg"
                className="max-w-[9.5rem] w-full"
              />
            </a>
          </div>

          <div className="max-w-44 w-full">
            <a
              href="https://play.google.com/store/apps/details?id=com.humanplusplus.sudowrite&pcampaignid=mobile_redirect"
              target="_blank"
            >
              <img
                src="/assets/get-it-on-playstore.png"
                alt="Get it on Google Play"
                className="w-full"
              />
            </a>
          </div>
        </div>
      </WithReset>
    </WithReset>
  );
};

export default MobileRedirect;
